import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useI18n } from "../context/I18nContext";
import { api, resolveImage } from "../lib/api";
import Seo from "../components/Seo";

export default function Rooms() {
  const { lang, t } = useI18n();
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/rooms");
        setRooms(r.data.items || []);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  return (
    <div data-testid="page-rooms" className="stoel-container pt-12 md:pt-20 pb-24">
      <Seo
        path="/ruimtes"
        titleNl="Ruimtes"
        titleEn="Rooms"
        descNl="Vijf werelden waarin onze selecties tot rust komen — thuiskantoor, leeskamer, vergaderruimte, advocatenkantoor, woonkamer."
        descEn="Five worlds where our selections come to rest — home office, reading room, boardroom, law office, living room."
      />
      <header className="mb-16 max-w-3xl">
        <div className="stoel-eyebrow mb-4">— {t.nav.rooms}</div>
        <h1 className="stoel-display text-5xl md:text-6xl lg:text-7xl">{t.rooms.title}</h1>
        <p className="mt-6 text-lg text-stoel-inkSoft leading-relaxed max-w-xl">
          {t.rooms.subtitle}
        </p>
      </header>

      <div className="grid md:grid-cols-2 gap-8 md:gap-12">
        {rooms.map((r, i) => (
          <Link
            key={r.id}
            to={`/ruimtes/${r.slug}`}
            data-testid={`room-card-${r.slug}`}
            className={`group ${i % 3 === 0 ? "md:col-span-2" : ""}`}
          >
            <div className={`relative overflow-hidden bg-stoel-paperDeep ${i % 3 === 0 ? "aspect-[16/9]" : "aspect-[4/5]"}`}>
              <img
                src={resolveImage(r.hero_image_url)}
                alt={lang === "nl" ? r.title_nl : r.title_en}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                onError={(e) => {
                  e.currentTarget.src = resolveImage(null);
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-stoel-ink/60 via-stoel-ink/10 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 text-stoel-paper">
                <div className="text-[10px] uppercase tracking-[0.3em] opacity-80 mb-2">
                  0{i + 1} / 0{rooms.length}
                </div>
                <h2 className="text-3xl md:text-4xl font-light tracking-tight">
                  {lang === "nl" ? r.title_nl : r.title_en}
                </h2>
                <p className="mt-2 text-sm opacity-85 max-w-md line-clamp-2">
                  {lang === "nl" ? r.intro_nl : r.intro_en}
                </p>
                <div className="mt-4 inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em]">
                  {t.common.view} <ArrowRight size={14} />
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
